import { createSelector } from "reselect";
import { feedEntitiesByTypeSelector } from "orion-components/GlobalData/Selectors";

export const selectCameraEntity = (cameraId, isOnAlertProfile) =>
	createSelector(
		(state) => state,
		(state) => {
			const cameraEntities = isOnAlertProfile
				? state?.contextualData?.[cameraId]?.entity
				: feedEntitiesByTypeSelector("camera")(state);

			if (isOnAlertProfile && (!cameraEntities || Object.values(cameraEntities).length === 0)) {
				return "Not available";
			} else if (!isOnAlertProfile && !cameraEntities?.[cameraId] && cameraId !== "") {
				return "Not available";
			}

			return isOnAlertProfile ? cameraEntities : cameraEntities?.[cameraId] || {};
		}
	);
